<template>
  <span>
    <span @click="setFilter()"  v-if="filter === name">
      <i v-if="direction === 'asc'" class="el-icon-bottom ml-4 cursor-pointer text-gray-800"></i>
      <i v-if="direction === 'desc'" class="el-icon-top ml-4 cursor-pointer text-gray-800"></i>
    </span>
    <span v-else @click="setFilter()">
      <i @click="setFilter('asc')" class="el-icon-bottom ml-4 cursor-pointer text-gray-300"></i>
      <i @click="setFilter('desc')" class="el-icon-top ml-4 cursor-pointer text-gray-300"></i>
    </span>
  </span>
</template>

<script>
export default {
  name: 'TableHeaderFilter',
  data() {
    return {};
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    storePath: {
      type: Object,
      required: true,
    },
    commitPath: {
      type: String,
      required: true,
    },
  },
  computed: {
    filter() {
      return this.$store.state[this.storePath.module][this.storePath.subModule].filter;
    },
    direction() {
      return this.$store.state[this.storePath.module][this.storePath.subModule].direction;
    },
  },
  methods: {
    setFilter() {
      let order = 'asc';

      if (this.direction === order) {
        order = 'desc';
      }
      this.$store.commit(this.commitPath, { property: 'direction', payload: order });
      this.$store.commit(this.commitPath, { property: 'filter', payload: this.name });

      this.$emit('fetchData');
    },
  },
};
</script>

<style scoped>

</style>
